import { createAction } from '@reduxjs/toolkit';

import types from '../actionTypes';

const setAllUsersData = createAction(types.SET_ALL_USERS);

const setAllUsersDataByID = createAction(types.SET_USER_BY_ID);

export { setAllUsersData, setAllUsersDataByID };
